import { render, staticRenderFns } from "./SecondaryFiltersVT.vue?vue&type=template&id=2d21c306&scoped=true"
import script from "./SecondaryFiltersVT.vue?vue&type=script&lang=js"
export * from "./SecondaryFiltersVT.vue?vue&type=script&lang=js"
import style0 from "./SecondaryFiltersVT.vue?vue&type=style&index=0&id=2d21c306&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d21c306",
  null
  
)

export default component.exports